import { createTheme } from '@mui/material/styles';
import { colors as dizzarooColors } from '../theme/tokens';

/** Dizzaroo brand theme for Protocol Document Editor – Primary: Deep Blue #1E73BE */
export const documentEditorTheme = createTheme({
  palette: {
    primary: {
      main: dizzarooColors.primary[500],
      light: dizzarooColors.primary.light,
      dark: dizzarooColors.primary[600],
      contrastText: '#ffffff',
    },
    secondary: {
      main: dizzarooColors.accent.teal,
      light: dizzarooColors.accent.tealLight,
      dark: dizzarooColors.accent.tealDark,
      contrastText: '#ffffff',
    },
    background: { default: '#f5f5f5', paper: '#ffffff' },
  },
  typography: {
    fontFamily: '"Urbanist", "Inter", "SF Pro Display", "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
    h1: { fontFamily: '"Urbanist", sans-serif', fontWeight: 700 },
    h2: { fontFamily: '"Urbanist", sans-serif', fontWeight: 700 },
    h3: { fontFamily: '"Urbanist", sans-serif', fontWeight: 700 },
    h4: { fontFamily: '"Urbanist", sans-serif', fontWeight: 600 },
    h5: { fontFamily: '"Urbanist", sans-serif', fontWeight: 600 },
    h6: { fontFamily: '"Urbanist", sans-serif', fontWeight: 600 },
    subtitle1: { fontFamily: '"Urbanist", sans-serif', fontWeight: 500 },
    subtitle2: { fontFamily: '"Urbanist", sans-serif', fontWeight: 500 },
    body1: { fontFamily: '"Urbanist", sans-serif' },
    body2: { fontFamily: '"Urbanist", sans-serif' },
    button: { fontFamily: '"Urbanist", sans-serif', fontWeight: 500 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @import url('https://fonts.googleapis.com/css2?family=Urbanist:wght@300;400;500;600;700;800&display=swap');
      `,
    },
    MuiButton: {
      defaultProps: { color: 'primary', disableElevation: true },
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 8,
          // contained's '&.MuiButton-colorPrimary' below sets its own background
          // with the same CSS specificity (one class) as this rule — confirmed in
          // testing that the colorPrimary rule wins the tie, so a disabled primary
          // button rendered in full color instead of looking disabled. The nested
          // '&.Mui-disabled' inside colorPrimary below (two classes) is the actual
          // fix — plain CSS specificity, not dependent on !important support or
          // stylesheet order. This root-level rule is the fallback for any variant
          // with no color-specific override of its own.
          '&.Mui-disabled': {
            backgroundColor: dizzarooColors.neutral[100],
            color: dizzarooColors.neutral[500],
            borderColor: dizzarooColors.neutral[200],
          },
        },
        contained: {
          '&.MuiButton-colorPrimary': {
            backgroundColor: dizzarooColors.primary[500],
            '&:hover': { backgroundColor: dizzarooColors.primary[600] },
            '&.Mui-disabled': {
              backgroundColor: dizzarooColors.neutral[100],
              color: dizzarooColors.neutral[500],
            },
          },
        },
      },
    },
    MuiPaper: { styleOverrides: { root: { boxShadow: '0 2px 4px rgba(0,0,0,0.05)' } } },
  },
});
